<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 100 27"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :alt="$t('rewardlink-brand-footer')"
    :title="$t('rewardlink-brand-footer')"
    role="img"
  >
    <!-- eslint-disable no-tabs -->
    <g :fill="color">
      <g>
        <g>
          <path
            class="st0"
            d="M1.8,12.8H0V1h4.5c2.3,0,4.1,0.9,4.1,3.6c0,2.1-1.2,3-2.9,3.3c0.4,0.7,2.8,4.3,3.2,4.9H7L3.8,8h-2L1.8,12.8
				L1.8,12.8z M4.6,6.3c1.3,0,2.3-0.4,2.3-1.8c0-1.4-1-1.8-2.3-1.8H1.8v3.6L4.6,6.3L4.6,6.3z"
          />
          <path
            class="st0"
            d="M19.3,2.7v3.1h5.4v1.7h-5.4v3.6h6v1.7h-7.8V1h7.8v1.7C25.3,2.7,19.3,2.7,19.3,2.7z"
          />
          <path
            class="st0"
            d="M44.5,9.4L47.1,1H49l-4,12H44l-3.2-8.4L37.6,13h-1.1l-4-12h1.9l2.7,8.3l3.2-8.6h1L44.5,9.4z"
          />
          <path
            class="st0"
            d="M74.3,12.8h-1.8V1H77c2.3,0,4.1,0.9,4.1,3.6c0,2.1-1.2,3-2.9,3.3c0.4,0.7,2.8,4.3,3.2,4.9h-2L76.3,8h-2
				L74.3,12.8L74.3,12.8z M77,6.3c1.3,0,2.3-0.4,2.3-1.8c0-1.4-1-1.8-2.3-1.8h-2.7v3.6L77,6.3L77,6.3z"
          />
          <path
            class="st0"
            d="M89.8,1h4.3c3.7,0,5.8,2.5,5.8,5.9c0,3.4-2,5.9-5.7,5.9h-4.5L89.8,1L89.8,1z M94.3,11.1
				c2.6,0,3.8-1.7,3.8-4.2c0-2.4-1.4-4.2-4-4.2h-2.5v8.4H94.3z"
          />
          <polygon
            class="st0"
            points="59.6,0 53.6,12.8 59.5,12.8 59.5,11.1 56.3,11.1 59.6,4.1 63.3,12.8 65.3,12.8 			"
          />
        </g>
      </g>
      <g>
        <path
          class="st0"
          d="M37.1,20.3h1.1v5.5h3.4v1h-4.6V20.3z"
        />
        <path
          class="st0"
          d="M44.5,20.3h1.1v6.5h-1.1V20.3z"
        />
        <path
          class="st0"
          d="M48.9,20.3H50l3.5,4.5v-4.5h1.1v6.5h-1L50,22.2v4.6h-1.1L48.9,20.3L48.9,20.3z"
        />
        <path
          class="st0"
          d="M57.8,20.3H59v3.3l3.1-3.3h1.4l-2.7,2.8l2.8,3.7h-1.4L60,23.9l-1,1v1.9h-1.1L57.8,20.3L57.8,20.3z"
        />
      </g>
      <g>
        <path
          class="st0"
          d="M67.7,21.8c0,0.3,0,0.5-0.1,0.7s-0.2,0.4-0.4,0.5c-0.2,0.1-0.3,0.3-0.5,0.3c-0.2,0.1-0.4,0.1-0.6,0.1
		c-0.2,0-0.5,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.3-0.3-0.3-0.5c-0.1-0.2-0.1-0.4-0.1-0.7c0-0.3,0-0.5,0.1-0.7
		c0.1-0.2,0.2-0.4,0.4-0.5c0.2-0.1,0.3-0.3,0.5-0.3c0.2-0.1,0.4-0.1,0.6-0.1s0.4,0,0.6,0.1c0.2,0.1,0.4,0.2,0.5,0.3s0.3,0.3,0.4,0.5
		C67.6,21.3,67.7,21.6,67.7,21.8z M67.3,21.8c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.3
		c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.1,0.4-0.1,0.6
		c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.1,0.3,0.3,0.4c0.1,0.1,0.3,0.2,0.4,0.3s0.3,0.1,0.6,0.1c0.2,0,0.4,0,0.5-0.1
		c0.2-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.3,0.3-0.4C67.3,22.2,67.3,22,67.3,21.8z M65.6,22.8h-0.3v-1.9h0.7c0.2,0,0.4,0,0.5,0.1
		c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.1l0.5,0.8h-0.3L65.9,22h-0.3L65.6,22.8L65.6,22.8z M66,21.7
		c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.2c0-0.1,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0
		c0,0-0.1,0-0.1,0h-0.4v0.6L66,21.7L66,21.7z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'RewardLinkLogo',
  props: {
    width: {
      type: String,
      required: false,
      default: '100px'
    },
    height: {
      type: String,
      required: false,
      default: '27px'
    },
    color: {
      type: String,
      required: false,
      default: '#FFFFFF'
    }
  }
}
</script>
